import { State } from "../../../redux/state";

const uniqueEntityList = <T>(state: {
  ids: string[];
  entities: Record<string, T>;
}) =>
  Array.from(new Set(state.ids))
    .map((id) => state.entities[id])
    .filter(Boolean);

export const supportConfigSelector = (state: State) =>
  state.wembiiSupport.config;

export const supportConversationsSelector = (state: State) =>
  state.wembiiSupport.conversations;

export const supportConversationsListSelector = (state: State) =>
  uniqueEntityList(state.wembiiSupport.conversations);

export const selectedSupportConversationSelector = (state: State) =>
  state.wembiiSupport.selected;

export const supportMessagesSelector = (state: State) =>
  uniqueEntityList(state.wembiiSupport.messages);

export const supportVisitorsListSelector = (state: State) =>
  uniqueEntityList(state.wembiiSupport.visitors);

export const supportOnlineAgentsSelector = (state: State) =>
  state.wembiiSupport.onlineAgents ?? [];

export const supportAgentSocketSubscriptionSelector = (state: State) =>
  state.wembiiSupport.agentSocketSubscription ?? null;

export const widgetSessionSelector = (state: State) =>
  state.wembiiSupport.widgetSession;
